{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "La extensión de Chrome no está instalada.",
      "CTA": "Instalar extensión"
    },
    "STATUS": {
      "OFFLINE": "Teléfono desconectado",
      "IN_OTHER_TAB": "Teléfono conectado en otra pestaña",
      "CONNECTING": "Conectando...",
      "DISCONNECTING": "Desconectando...",
      "ONLINE": "Teléfono en línea",
      "DIALING": "Marcando",
      "TRANSFERRING": "Transfiriendo...",
      "CONSULTING": "Hablando con el agente",
      "CALLER_ON_HOLD": "La llamada está retenida",
      "BUSY": "Ocupado",
      "DND": "DND",
      "UNAVAILABLE": "No disponible",
      "REJECTED": "Llamada rechazada",
      "CALL_FAILED": "La llamada falló"
    },
    "QUEUES": {
      "MORE": "Más colas"
    },
    "TABS": {
      "PHONE": "Teléfono",
      "SMS": "SMS",
      "HISTORY": "Historial"
    },
    "HISTORY": {
      "OPEN": "Abiertas",
      "RECENT": "Recientes",
      "MISSED": "Perdidas",
      "LOADING": "Cargando llamadas...",
      "EMPTY": "No hay llamadas",
      "ERROR": "No se pudieron cargar las llamadas",
      "CALL": "Devolver llamada",
      "CALL_STATUS": {
        "BUTTON": "Establecer estado de llamada",
        "TITLE": "Estado de llamada",
        "SEARCH_PLACEHOLDER": "Buscar estados...",
        "LOADING": "Cargando estados...",
        "NO_OPTIONS": "No hay estados de llamada configurados",
        "NO_MATCH": "Ningún estado coincide",
        "OPTIONS_ERROR": "No se pudieron cargar los estados",
        "RETRY": "Intentar de nuevo",
        "CONFIRM_QUESTION": "¿Establecer «{status}» y resolver la conversación?",
        "CONFIRM": "Confirmar",
        "BACK": "Atrás",
        "CANCEL": "Cancelar",
        "SAVING": "Guardando...",
        "SAVE_ERROR": "No se pudo guardar el estado",
        "RESOLVE_ERROR": "Estado guardado, pero no se pudo resolver la conversación"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Número de teléfono, p. ej. +421903000000",
      "BODY_PLACEHOLDER": "Escribe tu mensaje...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Enviar SMS",
      "SENDING": "Enviando...",
      "SENT": "SMS enviado",
      "LOADING": "Cargando bandejas de entrada de SMS...",
      "NO_INBOX": "Esta cuenta no tiene una bandeja de entrada de SMS, por lo que no se puede enviar el SMS.",
      "INVALID_NUMBER": "Introduce el número en formato internacional, incluido el + inicial.",
      "ERROR": "No se ha podido enviar el SMS. Inténtalo de nuevo."
    },
    "ACTIONS": {
      "CONNECT": "Conectar",
      "GO_TO_TAB": "Ir a esa pestaña",
      "DISCONNECT": "Desconectar",
      "ANSWER": "Contestar",
      "HANGUP": "Colgar",
      "HOLD": "Retener",
      "MUTE": "Silenciar micrófono",
      "SILENCE": "Silenciar audio",
      "TRANSFER": "Transferir",
      "COMPLETE_TRANSFER": "Completar transferencia",
      "RETURN_TO_CALLER": "Volver al llamante",
      "CANCEL_TRANSFER": "Cancelar transferencia",
      "DIALPAD": "Mostrar teclado",
      "OPEN_CONVERSATION": "Abrir conversación"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Llamada entrante",
      "INCOMING_CALL_FROM": "Llamada entrante de {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Llamada entrante de {number}",
      "ANSWER": "Contestar",
      "DECLINE": "Rechazar"
    },
    "TRANSFER": {
      "TITLE": "Transferir llamada",
      "PLACEHOLDER": "Introduce el número de destino de la transferencia...",
      "SEARCH_PLACEHOLDER": "Buscar agentes...",
      "TARGET_PLACEHOLDER": "Destino de transferencia seleccionado",
      "CONFIRM": "Transferir",
      "MODE_DIRECT": "Transferir ahora",
      "MODE_CONSULT": "Llamar primero al agente",
      "CANCEL": "Cancelar"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "¿Estás seguro de que deseas tomar un descanso para todas las colas?",
      "CONFIRM_READY": "¿Estás seguro de que deseas volver al estado listo para todas las colas?",
      "CONFIRM_BREAK_QUEUE": "¿Estás seguro de que deseas cerrar sesión en la cola {queue}?",
      "CONFIRM_READY_QUEUE": "¿Estás seguro de que deseas iniciar sesión en la cola {queue}?",
      "LOGIN_TO_QUEUE": "Iniciar sesión",
      "LOGOUT_FROM_QUEUE": "Cerrar sesión",
      "LOGIN_TO_ALL_QUEUES": "Iniciar sesión en todas las colas",
      "LOGOUT_FROM_ALL_QUEUES": "Cerrar sesión en todas las colas",
      "OPTION_LOGOUT": "Cerrar sesión",
      "OPTION_BREAK": "Pausa",
      "OPTION_LUNCH": "Almuerzo",
      "OPTION_AWAY": "Ausente",
      "OPTION_DO_NOT_DISTURB": "No molestar",
      "OPTION_BUSINESS_TRIP": "Viaje de negocios",
      "CONFIRM": "Confirmar",
      "CANCEL": "Cancelar"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Sin conexión con el sistema telefónico",
      "MESSAGE": "Parece que tu conexión a Internet no funciona. Compruébala e inténtalo de nuevo.",
      "CREDENTIALS_TITLE": "El sistema telefónico rechazó tus credenciales",
      "CREDENTIALS_MESSAGE": "El sistema telefónico rechazó el nombre de usuario o la contraseña guardados en tu perfil. Compruébalos en Ajustes del perfil, o consulta a tu administrador.",
      "CONFIGURATION_TITLE": "La configuración del teléfono no es válida",
      "CONFIGURATION_MESSAGE": "El nombre de usuario SIP o la dirección del servidor no tiene un formato válido, por lo que el teléfono no puede conectarse. Corrígelo en Ajustes del perfil.",
      "NETWORK_SHORT": "Conexión fallida",
      "CREDENTIALS_SHORT": "Credenciales rechazadas",
      "CONFIGURATION_SHORT": "Configuración de teléfono no válida",
      "RETRY": "Intentar de nuevo",
      "DISMISS": "Cancelar"
    },
    "CONNECTION_QUALITY": "Calidad de la conexión",
    "CONNECTION_QUALITY_EXCELLENT": "Excelente",
    "CONNECTION_QUALITY_GOOD": "Buena",
    "CONNECTION_QUALITY_FAIR": "Regular",
    "CONNECTION_QUALITY_POOR": "Mala",
    "CONNECTION_QUALITY_DISCONNECTED": "Desconectado"
  },
  "DIAL_REDIRECT": {
    "DIALING": "Marcando {number}… Puedes cerrar esta pestaña.",
    "NO_NUMBER": "No se proporcionó ningún número. Usa ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Introduce el número de teléfono...",
    "ACTIONS": {
      "DIAL": "Marcar número",
      "DIAL_FROM": "Elige el número desde el que llamas"
    },
    "DIAL_FROM": {
      "TITLE": "Llamar desde el número de una bandeja de entrada"
    },
    "VALIDATION": {
      "REQUIRED": "El número de teléfono es obligatorio",
      "INVALID_FORMAT": "Formato de número de teléfono inválido"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Configuración y prueba de audio",
    "SELECT_DEVICE": "Seleccionar dispositivo...",
    "SYSTEM_DEFAULT": "Predeterminado del sistema",
    "SAVED": "Guardado",
    "DISCONNECTED_SUFFIX": "no conectado",
    "DEVICE_DISCONNECTED": "El dispositivo seleccionado no está conectado. Las llamadas usan el predeterminado del sistema hasta que vuelva.",
    "MICROPHONE": {
      "TITLE": "Micrófono",
      "START_TEST": "Probar micrófono",
      "STOP_TEST": "Detener prueba",
      "LEVEL": "Nivel:",
      "VERDICT": {
        "LISTENING": "Diga algo al micrófono…",
        "SILENT": "No se le oye. Compruebe que el micrófono esté encendido y que esté seleccionado el correcto.",
        "LOW": "Se le oye muy bajo. Seleccione otro micrófono o ajuste el volumen de entrada en la configuración del sistema.",
        "GOOD": "Buen sonido: se le oye bien."
      }
    },
    "SPEAKER": {
      "TITLE": "Altavoz",
      "TEST": "Probar altavoz",
      "TESTING": "Probando...",
      "VOLUME": "Volumen:",
      "USING_DEFAULT": "La salida seleccionada no está disponible: se reprodujo en la predeterminada del sistema."
    },
    "DONE": "Listo",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Error al acceder al micrófono. Por favor, comprueba los permisos.",
      "MICROPHONE_PERMISSION_DENIED": "El acceso al micrófono está bloqueado. Permítelo en la configuración del sitio de tu navegador para usar el teléfono.",
      "MICROPHONE_SILENT": "Tu micrófono no está captando ningún sonido. Revisa la configuración de audio.",
      "EXTENSION_REQUIRED": "No se detectó la extensión del teléfono. Instálala o actívala para usar el micrófono.",
      "SPEAKER_TEST": "Error al probar la salida del altavoz."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Desconectado",
    "ONLINE": "En línea",
    "BUSY": "Ocupado"
  },
  "QUEUE_STATUS": {
    "READY": "Listo",
    "NOT_READY": "No acepta llamadas",
    "WRAP_UP": "Finalización",
    "BREAK": "Descanso",
    "LUNCH": "Almuerzo",
    "AWAY": "Ausente",
    "DO_NOT_DISTURB": "No molestar",
    "BUSINESS_TRIP": "Viaje de negocios",
    "OTHER_CALL": "Otra llamada",
    "QUEUE_CALL": "Llamada de cola",
    "OFFLINE": "Desconectado",
    "ONLINE": "En línea",
    "NO_ACCESS": "Sin teléfono",
    "PARTIALLY_READY": "Parcialmente listo",
    "MIXED": "Mixto",
    "CHAT_ONLINE": "En línea (chat)",
    "CHAT_BUSY": "Ocupado (chat)",
    "CHAT_OFFLINE": "Desconectado (chat)"
  }
}
